import { useState, useEffect } from "react";

const useCities = () => {
  const [cities, setCities] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchCities = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/location/cities`);

      if (!response.ok) {
        throw new Error("Failed to fetch cities");
      }

      const citiesData = await response.json();
      setCities(citiesData || []);
    } catch (err) {
      setError(err instanceof Error ? err.message : "An error occurred");
      console.error("Error fetching cities:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCities();
  }, []);

  return { cities, loading, error, refetch: fetchCities };
};

export default useCities;
